import {HTTP} from "./util"

const DomesticCustomerWrapper = {

    init : (config) => {
        return {
            validate: async function (data= { customerCode : null , accountNumber : null }) {
                const url = `${config.url}/freight-customer/domesticcustomer/validate`;
                let p = Promise.resolve();
                let response = undefined;
                try{
                    response = await HTTP.post(url ,{"customerCode" : data.customerCode , "accountNumber" : data.accountNumber });
                    if(response.ok){
                        let json = await response.json();
                        let obj = {
                            success: true,
                            data: {
                                accountNumber: data.accountNumber,
                                customerCode: json.customerCode,
                                country: {value: json ? json.countryCode : "", label: json ? json.countryName : ""},
                                name: json ? json.customerName : "",
                                postcode: json ? json.postCode: "",
                                city: json ? json.city: "",
                                state: json ? json.state: "",
                                streetaddress: json ? [
                                    json.shopNumber || "",
                                    json.streetNumber || "",
                                    json.streetName || "",
                                    json.streetType || ""
                                ].filter(Boolean).join(" ") : "",
                            }
                        };
                        p = Promise.resolve(obj)
                    }
                    else if(response.status === 404 ){
                        p = Promise.reject({status : response.status  , data : data , message : "Sorry we can't find your details"})
                    }
                    else{
                        p = Promise.reject({status : response.status , data : data , message : "Backend Technical problem"})
                    }
                }catch( e ){
                    p = Promise.reject({status : 0 , data : data , message : e.message})
                }

                return p;
            },
        }
    }

};

const DomesticCustomer = (config) => {
    return DomesticCustomerWrapper.init(config);
};

export {

    DomesticCustomer
}
